import * as _ from 'underscore';
import { Messages } from '../../../gen-src/Localize';
import { IUser } from '../../search/models/IUser';
import { IUserInfo } from '../../search/models/IUserInfo';
export namespace UserMapper {
  export function map(serverApiUsers: IUser[]): IUserInfo[] {
    return _.map(serverApiUsers, mapOne);
  }

  export function mapOne(u?: IUser): IUserInfo {
    if (!u) {
      u = {
        displayName: Messages.hiddenUser(),
        username: '',
        id: '0',
        isHiddenInternalUser: true,
      };
    }
    return {
      authId: u.authId,
      displayName: u.isHiddenInternalUser ? Messages.hiddenUser() : u.displayName || '',
      domainName: u.domainName || '',
      id: u.id,
      readOnly: u.readOnly || false,
      username: u.username,
      isHiddenInternalUser: u.isHiddenInternalUser || false,
    };
  }
}
